import React from 'react';
import {OrderStatusDescription, OrderStatus} from "../../models/order";
import Chip from '@mui/joy/Chip';
import CustomIcon from '../../components/customIcon/CustomIcon';

type DefaultProps = {
    status?: OrderStatus
}

export function OrderStatusIcon(props: DefaultProps) {
    const {status} = props;
    return (
        <React.Fragment>
            <Chip
                variant="soft"
                size="sm"
                startDecorator={<CustomIcon IconComponent={OrderStatus.getIcon(status)}/>}
                color={OrderStatus.getColor(status)}
            >
                {status ? OrderStatusDescription[status] : 'Не определен'}
            </Chip>
        </React.Fragment>
    );
}